<template>
  <div class="client-statistics" style="display:flex;justify-content: space-around">
    <div class="statistics-item"  style="cursor: pointer;" @click="totalCountClick">
      <div>客户总数</div>
      <div>{{clientCount.total_count}}</div>
    </div>
    <div class="statistics-item">
      <div>本年新增</div>
      <div>{{clientCount.this_month_new_client}}</div>
    </div>
    <div class="statistics-item">
      <div></div>
      <div></div>
    </div>
    <div class="statistics-item">
      <div></div>
      <div></div>
    </div>
  </div>
</template>

<script>
import {getClientCount} from "@/api/api";

export default {
  name: "ClientStatistics",
  data(){
    return {
      clientCount:{}
    }
  },
  async mounted() {
    const {respData} = await getClientCount({})
    this.clientCount = respData
  },

  methods: {
    totalCountClick(){
      this.$emit('totalCountClick')
    }
  }

}
</script>

<style scoped>
  .client-statistics{
    width: 95%;
    box-shadow:0 2px 12px 0 rgb(0 0 0 / 10%);
    border-radius: 5px;
    padding: 20px;
    font-size: 14px;
  }
  .statistics-item{
    text-align: center;
  }
  .statistics-item > div:first-child{
    padding: 5px 0;
  }
</style>